import type { Container, Sprite, Text } from 'pixi.js';
import { PredefinedVisualType } from '../types';
import { CollectEventHiveHarvestTokenLayout } from '../../../../layouts/collectEvent/CollectEventHiveHarvestTokenLayout';
import { CollectEventHiveHarvestImageLayout } from '../../../../layouts/collectEvent/CollectEventHiveHarvestImageLayout';
import { preloadLayoutsAssets } from '../../../views/preloadLayoutsAssets';
import { CollectEventMagicSpellTokenLayout } from '../../../../layouts/collectEvent/CollectEventMagicSpellTokenLayout';
import { CollectEventMagicSpellImageLayout } from '../../../../layouts/collectEvent/CollectEventMagicSpellImageLayout';
import { CollectEventWhittleWoodsTokenLayout } from '../../../../layouts/collectEvent/CollectEventWhittleWoodsTokenLayout';
import { CollectEventWhittleWoodsImageLayout } from '../../../../layouts/collectEvent/CollectEventWhittleWoodsImageLayout';
import { CollectEventFiredUpForgeTokenLayout } from '../../../../layouts/collectEvent/CollectEventFiredUpForgeTokenLayout';
import { CollectEventFiredUpForgeImageLayout } from '../../../../layouts/collectEvent/CollectEventFiredUpForgeImageLayout';

export interface CollectionEventIconLayoutInstance {
  root: Container;
  icon: Sprite;
  amountText: Text;
}

export interface CollectionEventImageLayoutInstance {
  root: Container;
}

export const collectionEventPredefinedStyles: Record<
  PredefinedVisualType,
  {
    icon: () => CollectionEventIconLayoutInstance;
    image: () => CollectionEventImageLayoutInstance;
    preload: () => Promise<boolean>;
  }
> = {
  [PredefinedVisualType.Bee]: {
    icon: () => new CollectEventHiveHarvestTokenLayout(),
    image: () => new CollectEventHiveHarvestImageLayout(),
    preload: () =>
      preloadLayoutsAssets([CollectEventHiveHarvestTokenLayout, CollectEventHiveHarvestImageLayout], false),
  },
  [PredefinedVisualType.Unicorn]: {
    icon: () => new CollectEventMagicSpellTokenLayout(),
    image: () => new CollectEventMagicSpellImageLayout(),
    preload: () => preloadLayoutsAssets([CollectEventMagicSpellTokenLayout, CollectEventMagicSpellImageLayout], false),
  },
  [PredefinedVisualType.Leaf]: {
    icon: () => new CollectEventWhittleWoodsTokenLayout(),
    image: () => new CollectEventWhittleWoodsImageLayout(),
    preload: () =>
      preloadLayoutsAssets([CollectEventWhittleWoodsTokenLayout, CollectEventWhittleWoodsImageLayout], false),
  },
  [PredefinedVisualType.Flame]: {
    icon: () => new CollectEventFiredUpForgeTokenLayout(),
    image: () => new CollectEventFiredUpForgeImageLayout(),
    preload: () =>
      preloadLayoutsAssets([CollectEventFiredUpForgeTokenLayout, CollectEventFiredUpForgeImageLayout], false),
  },
};
